<template>
  <div class="banner">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.banner {
  background: $color-outer-space;
  height: calc(100vh - 80px);
  position: relative;
  overflow: hidden;
  width: 100%;

  > .grid {
    height: 100%;
  }
}

.banner__bg {
  background-size: cover;
  background-position: center;
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.banner--stars {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#092d6c+0,10659c+40,7babbf+68,e9c39f+85,ff9a4a+100 */
  background: linear-gradient(
    to bottom,
    #092d6c 0%,
    #10659c 40%,
    #7babbf 68%,
    #e9c39f 85%,
    #ff9a4a 100%
  );
}

.banner--error {
  background: linear-gradient(to bottom, #092d6c 0%, #10659c 50%, #7babbf 78%);
}

/* https://codepen.io/echoghi/pen/dMzaPb?js-preprocessor=babel */
@keyframes shootingStar {
  0% {
    top: -100px;
  }
  35% {
    top: calc(100% + 100px);
  }
  100% {
    top: calc(100% + 100px);
  }
}

.shooting-star {
  position: absolute;
  left: 45%;
  height: 100%;
  top: 0;
  transform: rotate(20deg);
}

.shooting-star__star {
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: -100px;
  width: 3px;
  height: 3px;
  background-color: fade(#fff, 95%);
  animation-duration: 20s;
  animation-name: shootingStar;
  animation-delay: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  transform: rotate(180deg);

  &:before {
    position: absolute;
    display: block;
    content: '';
    height: 85px;
    right: 1px;
    top: 0;
    width: 1px;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 100%
    );
  }
}

.banner__ground {
  background: linear-gradient(to bottom, #282d27 0%, #333b32 100%);
  bottom: 0;
  height: 50px;
  left: 0;
  position: absolute;
  width: 100%;

  &--middle {
    box-shadow: 0 -4px 3px rgba(80, 42, 0, 0.2);
  }
}

.banner__tent,
.banner__campfire {
  bottom: 100%;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}

.banner__tent {
  filter: drop-shadow(0 0 2px #473726);
  margin-bottom: -1px;
  margin-left: 105px;
  width: 200px;
}

.tnt-cls-1,
.tnt-cls-3,
.cf-cls-1 {
  fill: #282d27;
}
.tnt-cls-2 {
  fill: #181c18;
}
.tnt-cls-3 {
  stroke: #181c18;
  stroke-miterlimit: 10;
  stroke-width: 6px;
}

.banner__campfire {
  margin-bottom: -22px;
  margin-left: 222px;
}

.banner__campfire svg {
  width: 122px;
  position: relative;
}

/* https://codepen.io/BrianBravo/pen/JaFfz */
$orange: #f76b21;
$red: #f73d22;
$yellow: #f6c220;
$blue: rgb(0, 55, 255);

.banner__campfire-fire {
  height: 70px;
  left: 50%;
  position: absolute;
  margin-left: 2px;
  top: 25px;
  transform: translateX(-50%);
  width: 70px;
}

.banner__campfire-flame {
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0.9;
  width: 100%;
  height: 100%;
  border-bottom-right-radius: 70%;
  border-bottom-left-radius: 70%;
  border-top-left-radius: 70%;
  transform: rotate(-45deg) skew(-10deg, -10deg);
  background-color: $red;
  background: linear-gradient(to left, $red, $orange);
  z-index: 1;

  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-name: burn-left;
  animation-duration: 300ms;

  &:nth-of-type(2n) {
    animation-name: burn-right;
    animation-duration: 400ms;
  }

  &:nth-of-type(2) {
    height: 80%;
    width: 80%;
    left: 10%;
    background-color: $orange;
    background-image: linear-gradient(
      to left,
      fade($orange, 90%) 0%,
      fade($yellow, 90%) 100%
    );
    z-index: 2;
  }

  &:nth-of-type(3) {
    height: 50%;
    width: 50%;
    left: 25%;
    background-image: linear-gradient(to left, $yellow, white);
    z-index: 3;
  }

  &:nth-of-type(4) {
    height: 30%;
    width: 30%;
    left: 35%;
    background-color: white;
    background-image: linear-gradient(
      to left,
      fade(white, 70%) 0%,
      fade($blue, 40%) 100%
    );
    opacity: 1;
    z-index: 4;
  }
}

.banner__campfire-spark {
  position: absolute;
  bottom: 50%;
  left: 25%;
  width: 4px;
  height: 4px;
  background: rgba(255, 106, 0, 0.4);
  opacity: 0;

  animation-name: fly-up-burnout-1;
  animation-duration: 6s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-delay: 0.4s;

  &:nth-of-type(2n) {
    animation-name: fly-up-burnout-2;
    animation-duration: 8.4s;
    animation-delay: 1s;
  }
  &:nth-of-type(3n) {
    animation-delay: 1.9s;
    animation-duration: 8s;
    left: 52%;
  }
  &:nth-of-type(4n) {
    animation-delay: 2.6s;
    animation-duration: 7s;
    left: 72%;
  }
  &:nth-of-type(5n) {
    animation-delay: 1.4s;
    animation-duration: 7s;
    left: 24%;
  }
  &:nth-of-type(6n) {
    animation-delay: 3.2s;
    left: 59%;
  }
  &:nth-of-type(7n) {
    animation-delay: 0.8s;
    animation-duration: 5s;
    left: 62%;
  }
  &:nth-of-type(8n) {
    animation-delay: 5s;
    left: 22%;
  }
  &:nth-of-type(9n) {
    animation-delay: 4s;
    animation-duration: 6.8s;
    left: 25%;
  }
  &:nth-of-type(10n) {
    animation-delay: 5.2s;
    left: 58%;
  }
  &:nth-of-type(11n) {
    animation-delay: 3.5s;
    animation-duration: 8s;
    left: 69%;
  }
  &:nth-of-type(12n) {
    animation-delay: 2s;
    left: 70%;
  }
}

@keyframes burn-left {
  0%,
  100% {
    transform: rotate(-45deg) skew(-10deg, -10deg) scale(1);
  }
  30%,
  60% {
    transform: rotate(-44deg) skew(-12deg, -12deg) scale(1.01);
  }
}

@keyframes burn-right {
  0%,
  100% {
    transform: rotate(-45deg) skew(-10deg, -10deg) scale(1);
  }
  30%,
  60% {
    transform: rotate(-46deg) skew(-6deg, -6deg) scale(1.01);
  }
}

@keyframes fly-up-burnout-1 {
  0% {
    transform: translate(0, 0);
    opacity: 1;
  }

  33% {
    transform: translate(12px, -70px);
  }

  66% {
    transform: translate(0, -140px);
    opacity: 0.6;
  }

  100% {
    transform: translate(6px, -200px);
    opacity: 0;
  }
}

@keyframes fly-up-burnout-2 {
  0% {
    transform: translate(0, 0);
    opacity: 1;
  }

  50% {
    transform: translate(-10px, -80px);
  }

  80% {
    transform: translate(-4px, -140px);
    opacity: 0.6;
  }

  100% {
    transform: translate(-6px, -160px);
    opacity: 0;
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  40% {
    transform: translateX(-50%) translateY(-12px);
  }
  60% {
    transform: translateX(-50%) translateY(-6px);
  }
}

.cf-cls-2 {
  fill: url(#linear-gradient);
}

.banner__tree-holder {
  position: absolute;
  bottom: 0;
  left: 50%;
  height: 100%;
  transform: translateX(-50%);
  width: 1px;
}

.banner__tree {
  fill: #282d27;
  position: absolute;
  bottom: 100%;
  height: 288px;
  filter: drop-shadow(0 0 1.5px #473726);
  width: 200px;
  margin-bottom: -10px;
}
.banner__tree--1 {
  right: 0;
  transform: translateX(-65%);
}
.banner__tree--2,
.banner__tree--4,
.banner__tree--5,
.banner__tree--9 {
  display: none;
}

.banner__tree--3 {
  height: 338px;
  left: 0;
  transform: translateX(50%);
  width: 235px;
}

.banner__sun {
  background: #fff;
  box-shadow: 0 0 5px 10px #ffeddd, 0 0 5px 20px rgba(255, 237, 221, 0.7),
    0 0 5px 30px rgba(255, 237, 221, 0.4),
    0 0 5px 40px rgba(255, 237, 221, 0.22);
  border-radius: 50%;
  left: 0;
  height: 30vh;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 0;
  width: 30vh;
}

.banner__content-container {
  height: 100%;
}

.banner__content {
  color: #fff;
  left: 50%;
  max-width: 850px;
  padding: 0 15px;
  position: absolute;
  top: 2vh;
  transform: translateX(-50%);
  text-align: center;
  width: 100%;

  &--left {
    left: 0;
    text-align: left;
    transform: none;
  }
}

.banner__title {
  font-size: 28px;
  margin: 20px 0;
}

.banner__text {
  font-size: 16px;
  line-height: 140%;
  margin-bottom: 30px;

  a {
    color: #fff;
    text-decoration: underline;

    &:hover {
      color: darken(#fff, 15%);
    }
  }
}

@media (min-width: 375px) {
  .banner__content {
    top: 4vh;
  }
}

@media (min-width: 544px) {
  /* homepage */
  .banner__tree {
    transform: none;
  }
  .banner__tree--1 {
    left: auto;
    right: 15vw;
  }
  .banner__tree--3 {
    left: 20vw;
  }
  .banner__content {
    top: 9vh;
  }
  .banner__title {
    font-size: 42px;
  }
}

@media (min-width: 768px) {
  /* homepage */
  .banner__tree {
    display: block;
  }
  .banner__tree--2 {
    height: 324px;
    right: 27vw;
    width: 225px;
  }
  .banner__tree--4 {
    left: 30vw;
  }
  .banner__tree--5 {
    left: 40vw;
    height: 324px;
    width: 225px;
  }

  .banner__text {
    font-size: 18ox;
  }
}

@media (min-width: 992px) {
  .banner__title {
    font-size: 50px;
  }

  .banner__text {
    font-size: 22px;
  }
}

///

.banner__stars {
  background: transparent;
  position: absolute;
}

.banner__stars--1 {
  box-shadow: 1605px 940px #fff, 833px 734px #fff, 1986px 830px #fff,
    1387px 123px #fff, 1400px 169px #fff, 251px 686px #fff, 1391px 411px #fff,
    658px 416px #fff, 1590px 363px #fff, 208px 205px #fff, 1189px 805px #fff,
    775px 392px #fff, 1165px 688px #fff, 1991px 259px #fff, 37px 645px #fff,
    134px 1039px #fff, 959px 1136px #fff, 1626px 381px #fff, 1494px 1702px #fff,
    566px 481px #fff, 234px 440px #fff, 655px 1191px #fff, 1646px 242px #fff,
    776px 627px #fff, 1966px 20px #fff, 1596px 80px #fff, 6px 552px #fff,
    1499px 1404px #fff, 864px 1978px #fff, 1608px 698px #fff, 237px 485px #fff,
    371px 199px #fff, 1030px 1423px #fff, 922px 1809px #fff, 688px 941px #fff,
    1709px 722px #fff, 329px 1775px #fff, 1016px 633px #fff, 1932px 340px #fff,
    63px 68px #fff, 1883px 503px #fff, 1153px 125px #fff, 1546px 417px #fff,
    1125px 113px #fff, 1372px 1315px #fff, 1197px 381px #fff, 1184px 665px #fff,
    1763px 599px #fff, 764px 594px #fff, 1652px 1423px #fff, 44px 714px #fff,
    1786px 821px #fff, 1764px 663px #fff, 679px 544px #fff, 1194px 630px #fff,
    1970px 168px #fff, 431px 1663px #fff, 1528px 424px #fff, 599px 501px #fff,
    14px 815px #fff, 1708px 1120px #fff, 1795px 387px #fff, 518px 970px #fff,
    699px 86px #fff, 215px 1858px #fff, 1845px 858px #fff, 172px 1769px #fff,
    565px 1699px #fff, 681px 382px #fff, 604px 1871px #fff, 628px 256px #fff,
    964px 292px #fff, 559px 192px #fff, 848px 478px #fff, 285px 861px #fff,
    1797px 583px #fff, 66px 1417px #fff, 275px 1453px #fff, 1989px 790px #fff,
    1379px 406px #fff, 1876px 510px #fff, 1111px 1274px #fff, 108px 1876px #fff,
    1449px 842px #fff, 1231px 245px #fff, 656px 998px #fff, 1246px 1382px #fff,
    1658px 588px #fff, 760px 1196px #fff, 1145px 1397px #fff, 1603px 409px #fff,
    947px 1101px #fff, 1752px 1888px #fff, 1694px 325px #fff, 398px 545px #fff,
    1838px 918px #fff, 60px 1784px #fff, 586px 878px #fff, 1752px 720px #fff,
    829px 1702px #fff, 459px 1457px #fff, 326px 1971px #fff, 1282px 224px #fff,
    1223px 155px #fff, 1070px 719px #fff, 684px 1259px #fff, 801px 1111px #fff,
    187px 1917px #fff, 795px 60px #fff, 1572px 1201px #fff, 757px 1738px #fff,
    1959px 513px #fff, 460px 1885px #fff, 1023px 1472px #fff, 703px 389px #fff,
    744px 808px #fff, 661px 1512px #fff, 1681px 287px #fff, 1530px 783px #fff,
    102px 576px #fff, 1734px 1369px #fff, 511px 72px #fff, 561px 262px #fff,
    1973px 1044px #fff, 918px 889px #fff, 1033px 802px #fff, 1544px 1491px #fff,
    1222px 1188px #fff, 192px 1188px #fff, 46px 835px #fff, 1519px 169px #fff,
    74px 1168px #fff, 701px 1057px #fff, 1690px 1108px #fff, 1868px 670px #fff,
    1590px 1053px #fff, 270px 1112px #fff, 1110px 431px #fff, 1290px 1545px #fff,
    1059px 354px #fff, 190px 1892px #fff, 293px 971px #fff, 833px 371px #fff,
    1071px 606px #fff, 228px 264px #fff, 1420px 740px #fff, 437px 1144px #fff,
    959px 179px #fff, 1153px 701px #fff, 1287px 80px #fff, 289px 498px #fff,
    1005px 1066px #fff;
  height: 1px;
  width: 1px;
}

.banner__stars--2 {
  box-shadow: 927px 720px #fff, 1358px 1063px #fff, 1024px 1421px #fff,
    1356px 239px #fff, 1569px 410px #fff, 608px 418px #fff, 1933px 398px #fff,
    1182px 1206px #fff, 51px 1267px #fff, 1477px 979px #fff, 1750px 1035px #fff,
    84px 380px #fff, 571px 509px #fff, 1112px 241px #fff, 1226px 125px #fff,
    1752px 1944px #fff, 1734px 361px #fff, 1915px 1070px #fff, 884px 432px #fff,
    1077px 4px #fff, 82px 776px #fff, 1917px 1567px #fff, 1380px 548px #fff,
    349px 179px #fff, 568px 1758px #fff, 1505px 303px #fff, 9px 758px #fff,
    910px 277px #fff, 432px 1214px #fff, 485px 134px #fff, 1582px 22px #fff,
    98px 778px #fff, 1698px 373px #fff, 1488px 268px #fff, 1607px 1078px #fff,
    1919px 861px #fff, 167px 898px #fff;
  height: 2px;
  width: 2px;
}

.banner__stars--3 {
  box-shadow: 526px 314px #fff, 156px 774px #fff, 277px 464px #fff,
    1984px 834px #fff, 1675px 1065px #fff, 1246px 981px #fff, 885px 929px #fff,
    1440px 985px #fff, 184px 33px #fff;
  height: 3px;
  width: 3px;
}
</style>
